module.exports = __webpack_public_path__ + "img-gestao@2x--d04e5e11.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/img-gestao@2x.jpg
// module id = 54
// module chunks = 0